var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _text92, _text93, _text94, _text95, _text96, _text97, _text98, _text99, _text100, _text101, _text102, _text103, _text104, _text105, _text106, _text107, _text108, _text109, _text110, _text111, _text112, _text113, _text114, _text115, _text116, _text117, _text118, _text119, _text120, _text121, _text122, _text123, _text124, _text125, _text126, _text127, _text128, _text129, _text130, _text131, _text132, _text133, _text134, _text135, _text136, _text137, _text138, _text139, _text140, _text141, _text142, _text143, _text144, _text145, _text146, _text147, _text148, _text149, _text150, _text151, _text152, _text153, _text154, _text155, _text156, _text157, _text158, _text159, _text160, _text161, _text162, _text163, _text164, _text165, _text166, _text167, _text168, _text169, _text170, _text171, _text172, _text173, _text174, _text175, _text176, _text177, _text178, _text179, _text180, _text181, _text182, _text183, _text184, _text185, _text186, _text187, _text188, _text189, _text190, _text191, _text192, _text193, _text194, _text195, _text196, _text197, _text198, _text199, _text200, _text201, _text202, _text203, _text204, _text205, _text206, _text207, _text208, _text209, _text210, _text211, _text212, _text213, _text214, _text215, _text216, _text217, _text218, _text219, _text220, _text221, _text222, _text223, _text224, _text225, _text226, _text227, _text228, _text229, _text230, _text231, _text232, _text233, _text234, _text235, _text236, _text237, _g, _text238, _text239, _text240, _text241, _text242, _text243, _text244, _text245, _text246, _text247, _text248, _text249, _text250, _text251, _text252, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 764.05994,
    y: 240.45016
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 764.05994,
    y: 240.45016
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 387.48553,
    y: 615.72418
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1345.33,
    y: 160.45016
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1345.33,
    y: 160.45016
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 532.33484,
    y: 294.69586
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 273.74991,
    y: -20.810837
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 273.74991,
    y: -20.810837
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 265.29617,
    y: -432.66043
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1371.7999,
    y: -237.27983
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1371.7999,
    y: -237.27983
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 538.93481,
    y: -1301.326
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1953.0699,
    y: -317.28986
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1953.0699,
    y: -317.28986
  }))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 683.78406,
    y: -1622.3643
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1563.95,
    y: -789.68988
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1563.95,
    y: -789.68988
  }))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 586.81451,
    y: -3518.0144
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 2145.21,
    y: -869.68988
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2145.21,
    y: -869.68988
  }))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 731.66382,
    y: -3839.043
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 312.40988,
    y: 545.03015
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 312.40988,
    y: 545.03015
  }))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 764.05994,
    y: 240.45013
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 764.05994,
    y: 240.45013
  }))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 387.48553,
    y: 615.73529
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 1345.33,
    y: 160.45013
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1345.33,
    y: 160.45013
  }))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 532.33484,
    y: 294.69714
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 273.74991,
    y: -20.809847
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 273.74991,
    y: -20.809847
  }))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 265.29617,
    y: -432.64923
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 1371.7999,
    y: -237.27985
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1371.7999,
    y: -237.27985
  }))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 538.93481,
    y: -1301.3248
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1953.0699,
    y: -317.27985
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1953.0699,
    y: -317.27985
  }))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 683.78406,
    y: -1622.3531
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1563.95,
    y: -789.67987
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1563.95,
    y: -789.67987
  }))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 586.81451,
    y: -3518.0034
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 2145.21,
    y: -869.68988
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2145.21,
    y: -869.68988
  }))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 731.66382,
    y: -3839.0417
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 312.40988,
    y: 545.03021
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 312.40988,
    y: 545.03021
  }))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 1351.9922,
    y: 138.48407
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1351.9922,
    y: 138.48407
  }))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 533.99902,
    y: 206.55257
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 1933.2622,
    y: 58.484062
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1933.2622,
    y: 58.484062
  }))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 678.84833,
    y: -114.4758
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 861.68213,
    y: -122.77693
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 861.68213,
    y: -122.77693
  }))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 411.80963,
    y: -841.83209
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 1959.7322,
    y: -339.24594
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1959.7322,
    y: -339.24594
  }))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 685.44824,
    y: -1710.4977
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 2541.0022,
    y: -419.25595
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2541.0022,
    y: -419.25595
  }))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 830.29755,
    y: -2031.536
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 2151.8821,
    y: -891.65601
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2151.8821,
    y: -891.65601
  }))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 733.328,
    y: -3927.1863
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 2733.1421,
    y: -971.65601
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2733.1421,
    y: -971.65601
  }))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 878.17731,
    y: -4248.2148
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 900.3421,
    y: 443.06406
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 900.3421,
    y: 443.06406
  }))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 764.05994,
    y: 240.45016
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 764.05994,
    y: 240.45016
  }))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 387.48553,
    y: 615.72418
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 1345.33,
    y: 160.45016
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1345.33,
    y: 160.45016
  }))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 532.33484,
    y: 294.69586
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 273.74991,
    y: -20.810837
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 273.74991,
    y: -20.810837
  }))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 265.29617,
    y: -432.66043
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 1371.7999,
    y: -237.27983
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1371.7999,
    y: -237.27983
  }))), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 538.93481,
    y: -1301.326
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 1953.0699,
    y: -317.28986
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1953.0699,
    y: -317.28986
  }))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 683.78406,
    y: -1622.3643
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 1563.95,
    y: -789.68988
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1563.95,
    y: -789.68988
  }))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 586.81451,
    y: -3518.0144
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    x: 2145.21,
    y: -869.68988
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2145.21,
    y: -869.68988
  }))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 731.66382,
    y: -3839.043
  })), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    x: 312.40988,
    y: 545.03015
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 312.40988,
    y: 545.03015
  }))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    x: -843.53326,
    y: 97.263725
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -843.53326,
    y: 97.263725
  }))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -13.128739,
    y: 41.142727
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    x: -262.26331,
    y: 17.263718
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -262.26331,
    y: 17.263718
  }))), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 131.72054,
    y: -279.88565
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    x: -1333.8433,
    y: -163.99727
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1333.8433,
    y: -163.99727
  }))), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -135.31812,
    y: -1007.2419
  })), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    x: -235.79332,
    y: -380.46628
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -235.79332,
    y: -380.46628
  }))), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 138.32048,
    y: -1875.9075
  })), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    x: 345.47665,
    y: -460.47629
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 345.47665,
    y: -460.47629
  }))), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 283.16977,
    y: -2196.9458
  })), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    x: -43.643269,
    y: -932.87634
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43.643269,
    y: -932.87634
  }))), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 186.20024,
    y: -4092.5959
  })), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    x: 537.6167,
    y: -1012.8763
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 537.6167,
    y: -1012.8763
  }))), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 331.04956,
    y: -4413.6245
  })), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    x: -1295.1833,
    y: 401.84372
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1295.1833,
    y: 401.84372
  }))), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    x: -1724.0884,
    y: -95.230324
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1724.0884,
    y: -95.230324
  }))), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -111.9175,
    y: -945.0332
  })), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    x: -2371.8547,
    y: -863.18207
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2371.8547,
    y: -863.18207
  }))), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -273.34106,
    y: -4026.6975
  })), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    x: -1665.5137,
    y: -1018.8139
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1665.5137,
    y: -1018.8139
  }))), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -97.320663,
    y: -4651.2222
  })), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    x: -767.60107,
    y: 192.72136
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -767.60107,
    y: 192.72136
  }))), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 5.793669,
    y: 424.19708
  })), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    x: -186.33101,
    y: 112.72135
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -186.33101,
    y: 112.72135
  }))), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 150.64293,
    y: 103.16872
  })), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    x: -1257.9111,
    y: -68.539642
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1257.9111,
    y: -68.539642
  }))), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -116.3957,
    y: -624.18762
  })), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    x: -159.86104,
    y: -285.00867
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -159.86104,
    y: -285.00867
  }))), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 157.24287,
    y: -1492.8531
  })), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    x: 421.40891,
    y: -365.01865
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 421.40891,
    y: -365.01865
  }))), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 302.09219,
    y: -1813.8915
  })), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    x: 32.288982,
    y: -837.4187
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32.288982,
    y: -837.4187
  }))), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 205.12263,
    y: -3709.5417
  })), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    x: 613.54895,
    y: -917.4187
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 613.54895,
    y: -917.4187
  }))), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 349.97192,
    y: -4030.5701
  })), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    x: -1219.2511,
    y: 497.30136
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1219.2511,
    y: 497.30136
  }))), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    x: -562.20642,
    y: 695.42023
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -562.20642,
    y: 695.42023
  }))), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 56.978271,
    y: 2441.4377
  })), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    x: 19.06358,
    y: 615.42023
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.06358,
    y: 615.42023
  }))), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 201.82753,
    y: 2120.4094
  })), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    x: -1052.5165,
    y: 434.15924
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1052.5165,
    y: 434.15924
  }))), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -65.211098,
    y: 1393.0529
  })), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    x: 45.53355,
    y: 217.69026
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45.53355,
    y: 217.69026
  }))), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 208.42747,
    y: 524.38727
  })), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    x: 626.80359,
    y: 137.68024
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 626.80359,
    y: 137.68024
  }))), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 353.27679,
    y: 203.34898
  })), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    x: 237.68358,
    y: -334.71979
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 237.68358,
    y: -334.71979
  }))), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.30725,
    y: -1692.3014
  })), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    x: 818.9436,
    y: -414.71979
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 818.9436,
    y: -414.71979
  }))), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 401.15656,
    y: -2013.3297
  })), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    x: -1013.8564,
    y: 1000.0002
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1013.8564,
    y: 1000.0002
  }))), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    x: -1505.9353,
    y: 617.31848
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1505.9353,
    y: 617.31848
  }))), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -178.20015,
    y: 2128.0295
  })), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    x: -924.66522,
    y: 537.31848
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -924.66522,
    y: 537.31848
  }))), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -33.350876,
    y: 1807.001
  })), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    x: -1996.2452,
    y: 356.05753
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1996.2452,
    y: 356.05753
  }))), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -300.38953,
    y: 1079.6447
  })), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    x: -898.19525,
    y: 139.58856
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -898.19525,
    y: 139.58856
  }))), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -26.750961,
    y: 210.97914
  })), _text120 || (_text120 = /*#__PURE__*/React.createElement("text", {
    x: -316.92526,
    y: 59.578552
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -316.92526,
    y: 59.578552
  }))), _text121 || (_text121 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 118.09834,
    y: -110.05908
  })), _text122 || (_text122 = /*#__PURE__*/React.createElement("text", {
    x: -706.04523,
    y: -412.82147
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -706.04523,
    y: -412.82147
  }))), _text123 || (_text123 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 21.128798,
    y: -2005.7095
  })), _text124 || (_text124 = /*#__PURE__*/React.createElement("text", {
    x: -124.78518,
    y: -492.82147
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -124.78518,
    y: -492.82147
  }))), _text125 || (_text125 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 165.9781,
    y: -2326.7378
  })), _text126 || (_text126 = /*#__PURE__*/React.createElement("text", {
    x: -1957.5853,
    y: 921.8985
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1957.5853,
    y: 921.8985
  }))), _text127 || (_text127 = /*#__PURE__*/React.createElement("text", {
    x: -1258.4823,
    y: 692.1637
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1258.4823,
    y: 692.1637
  }))), _text128 || (_text128 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -116.53455,
    y: 2428.3699
  })), _text129 || (_text129 = /*#__PURE__*/React.createElement("text", {
    x: -677.21228,
    y: 612.1637
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -677.21228,
    y: 612.1637
  }))), _text130 || (_text130 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 28.314713,
    y: 2107.3416
  })), _text131 || (_text131 = /*#__PURE__*/React.createElement("text", {
    x: -1748.7922,
    y: 430.90271
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1748.7922,
    y: 430.90271
  }))), _text132 || (_text132 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -238.72394,
    y: 1379.985
  })), _text133 || (_text133 = /*#__PURE__*/React.createElement("text", {
    x: -650.74231,
    y: 214.43373
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -650.74231,
    y: 214.43373
  }))), _text134 || (_text134 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 34.914658,
    y: 511.31946
  })), _text135 || (_text135 = /*#__PURE__*/React.createElement("text", {
    x: -69.472313,
    y: 134.42372
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -69.472313,
    y: 134.42372
  }))), _text136 || (_text136 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 179.76393,
    y: 190.28114
  })), _text137 || (_text137 = /*#__PURE__*/React.createElement("text", {
    x: -458.59232,
    y: -337.97632
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -458.59232,
    y: -337.97632
  }))), _text138 || (_text138 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 82.794418,
    y: -1705.3691
  })), _text139 || (_text139 = /*#__PURE__*/React.createElement("text", {
    x: 122.6677,
    y: -417.97632
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 122.6677,
    y: -417.97632
  }))), _text140 || (_text140 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 227.64369,
    y: -2026.3976
  })), _text141 || (_text141 = /*#__PURE__*/React.createElement("text", {
    x: -1710.1323,
    y: 996.74365
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1710.1323,
    y: 996.74365
  }))), _text142 || (_text142 = /*#__PURE__*/React.createElement("text", {
    x: -2124.5232,
    y: 9.907349
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2124.5232,
    y: 9.907349
  }))), _text143 || (_text143 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -332.35306,
    y: -309.40274
  })), _text144 || (_text144 = /*#__PURE__*/React.createElement("text", {
    x: -1543.2532,
    y: -70.092651
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1543.2532,
    y: -70.092651
  }))), _text145 || (_text145 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -187.50378,
    y: -630.43109
  })), _text146 || (_text146 = /*#__PURE__*/React.createElement("text", {
    x: -2614.8333,
    y: -251.35365
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2614.8333,
    y: -251.35365
  }))), _text147 || (_text147 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -454.54245,
    y: -1357.7874
  })), _text148 || (_text148 = /*#__PURE__*/React.createElement("text", {
    x: -1516.7832,
    y: -467.82266
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1516.7832,
    y: -467.82266
  }))), _text149 || (_text149 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -180.90384,
    y: -2226.4529
  })), _text150 || (_text150 = /*#__PURE__*/React.createElement("text", {
    x: -935.51318,
    y: -547.8327
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -935.51318,
    y: -547.8327
  }))), _text151 || (_text151 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -36.054565,
    y: -2547.4912
  })), _text152 || (_text152 = /*#__PURE__*/React.createElement("text", {
    x: -1324.6332,
    y: -1020.2327
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1324.6332,
    y: -1020.2327
  }))), _text153 || (_text153 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -133.02408,
    y: -4443.1416
  })), _text154 || (_text154 = /*#__PURE__*/React.createElement("text", {
    x: -743.37323,
    y: -1100.2325
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -743.37323,
    y: -1100.2325
  }))), _text155 || (_text155 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 11.825225,
    y: -4764.1699
  })), _text156 || (_text156 = /*#__PURE__*/React.createElement("text", {
    x: -2576.1733,
    y: 314.48734
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2576.1733,
    y: 314.48734
  }))), _text157 || (_text157 = /*#__PURE__*/React.createElement("text", {
    x: -3005.0781,
    y: -182.5867
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3005.0781,
    y: -182.5867
  }))), _text158 || (_text158 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -431.14056,
    y: -1295.5801
  })), _text159 || (_text159 = /*#__PURE__*/React.createElement("text", {
    x: -3652.8447,
    y: -950.53845
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3652.8447,
    y: -950.53845
  }))), _text160 || (_text160 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -592.56415,
    y: -4377.2441
  })), _text161 || (_text161 = /*#__PURE__*/React.createElement("text", {
    x: -2946.5034,
    y: -1106.1702
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2946.5034,
    y: -1106.1702
  }))), _text162 || (_text162 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -416.54373,
    y: -5001.769
  })), _text163 || (_text163 = /*#__PURE__*/React.createElement("text", {
    x: -2473.8115,
    y: 179.12769
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2473.8115,
    y: 179.12769
  }))), _text164 || (_text164 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -419.39612,
    y: 369.64807
  })), _text165 || (_text165 = /*#__PURE__*/React.createElement("text", {
    x: -1892.5414,
    y: 99.127693
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1892.5414,
    y: 99.127693
  }))), _text166 || (_text166 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -274.54684,
    y: 48.619778
  })), _text167 || (_text167 = /*#__PURE__*/React.createElement("text", {
    x: -2964.1213,
    y: -82.133308
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2964.1213,
    y: -82.133308
  }))), _text168 || (_text168 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -541.58551,
    y: -678.73657
  })), _text169 || (_text169 = /*#__PURE__*/React.createElement("text", {
    x: -1866.0714,
    y: -298.60233
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1866.0714,
    y: -298.60233
  }))), _text170 || (_text170 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -267.94693,
    y: -1547.4021
  })), _text171 || (_text171 = /*#__PURE__*/React.createElement("text", {
    x: -1284.8014,
    y: -378.61234
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1284.8014,
    y: -378.61234
  }))), _text172 || (_text172 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -123.09763,
    y: -1868.4403
  })), _text173 || (_text173 = /*#__PURE__*/React.createElement("text", {
    x: -1673.9214,
    y: -851.01239
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1673.9214,
    y: -851.01239
  }))), _text174 || (_text174 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -220.06714,
    y: -3764.0906
  })), _text175 || (_text175 = /*#__PURE__*/React.createElement("text", {
    x: -1092.6614,
    y: -931.01239
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1092.6614,
    y: -931.01239
  }))), _text176 || (_text176 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: -75.217865,
    y: -4085.1189
  })), _text177 || (_text177 = /*#__PURE__*/React.createElement("text", {
    x: -2925.4614,
    y: 483.70767
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2925.4614,
    y: 483.70767
  }))), _text178 || (_text178 = /*#__PURE__*/React.createElement("text", {
    x: 764.05377,
    y: 240.4323
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 764.05377,
    y: 240.4323
  }))), _text179 || (_text179 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 387.49582,
    y: 615.73248
  })), _text180 || (_text180 = /*#__PURE__*/React.createElement("text", {
    x: 1345.3333,
    y: 160.44568
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1345.3333,
    y: 160.44568
  }))), _text181 || (_text181 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 532.34552,
    y: 294.69278
  })), _text182 || (_text182 = /*#__PURE__*/React.createElement("text", {
    x: 273.73093,
    y: -20.812193
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 273.73093,
    y: -20.812193
  }))), _text183 || (_text183 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 265.28778,
    y: -432.65579
  })), _text184 || (_text184 = /*#__PURE__*/React.createElement("text", {
    x: 1371.8018,
    y: -237.27635
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1371.8018,
    y: -237.27635
  }))), _text185 || (_text185 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 538.93597,
    y: -1301.3285
  })), _text186 || (_text186 = /*#__PURE__*/React.createElement("text", {
    x: 1953.0813,
    y: -317.28424
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1953.0813,
    y: -317.28424
  }))), _text187 || (_text187 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 683.78564,
    y: -1622.3505
  })), _text188 || (_text188 = /*#__PURE__*/React.createElement("text", {
    x: 1563.9553,
    y: -789.67792
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1563.9553,
    y: -789.67792
  }))), _text189 || (_text189 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 586.80585,
    y: -3518.0098
  })), _text190 || (_text190 = /*#__PURE__*/React.createElement("text", {
    x: 2145.1995,
    y: -869.68579
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2145.1995,
    y: -869.68579
  }))), _text191 || (_text191 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 731.65552,
    y: -3839.032
  })), _text192 || (_text192 = /*#__PURE__*/React.createElement("text", {
    x: 312.3884,
    y: 545.01495
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 312.3884,
    y: 545.01495
  }))), _text193 || (_text193 = /*#__PURE__*/React.createElement("text", {
    x: 729.64001,
    y: 231.35997
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64001,
    y: 231.35997
  }))), _text194 || (_text194 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.90805,
    y: 579.25812
  })), _text195 || (_text195 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.35997
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.35997
  }))), _text196 || (_text196 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.75732,
    y: 258.21997
  })), _text197 || (_text197 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.900009
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.900009
  }))), _text198 || (_text198 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.71869,
    y: -469.1264
  })), _text199 || (_text199 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37001
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37001
  }))), _text200 || (_text200 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.3573,
    y: -1337.802
  })), _text201 || (_text201 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text202 || (_text202 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.20654,
    y: -1658.8303
  })), _text203 || (_text203 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77002
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77002
  }))), _text204 || (_text204 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.237,
    y: -3554.4807
  })), _text205 || (_text205 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78003
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78003
  }))), _text206 || (_text206 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.0863,
    y: -3875.519
  })), _text207 || (_text207 = /*#__PURE__*/React.createElement("text", {
    x: 277.98999,
    y: 535.94006
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.98999,
    y: 535.94006
  }))), _text208 || (_text208 = /*#__PURE__*/React.createElement("text", {
    x: 729.64001,
    y: 231.35997
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64001,
    y: 231.35997
  }))), _text209 || (_text209 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.90805,
    y: 579.25812
  })), _text210 || (_text210 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.35997
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.35997
  }))), _text211 || (_text211 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.75732,
    y: 258.21997
  })), _text212 || (_text212 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.900009
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.900009
  }))), _text213 || (_text213 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.71869,
    y: -469.1264
  })), _text214 || (_text214 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37001
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37001
  }))), _text215 || (_text215 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.3573,
    y: -1337.802
  })), _text216 || (_text216 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text217 || (_text217 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.20654,
    y: -1658.8303
  })), _text218 || (_text218 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77002
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77002
  }))), _text219 || (_text219 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.237,
    y: -3554.4807
  })), _text220 || (_text220 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78003
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78003
  }))), _text221 || (_text221 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.0863,
    y: -3875.519
  })), _text222 || (_text222 = /*#__PURE__*/React.createElement("text", {
    x: 277.98999,
    y: 535.94006
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.98999,
    y: 535.94006
  }))), _text223 || (_text223 = /*#__PURE__*/React.createElement("text", {
    x: 729.64001,
    y: 231.35997
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64001,
    y: 231.35997
  }))), _text224 || (_text224 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.90805,
    y: 579.25812
  })), _text225 || (_text225 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.35997
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.35997
  }))), _text226 || (_text226 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.75732,
    y: 258.21997
  })), _text227 || (_text227 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.900009
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.900009
  }))), _text228 || (_text228 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.71869,
    y: -469.1264
  })), _text229 || (_text229 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37001
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37001
  }))), _text230 || (_text230 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.3573,
    y: -1337.802
  })), _text231 || (_text231 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text232 || (_text232 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.20654,
    y: -1658.8303
  })), _text233 || (_text233 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77002
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77002
  }))), _text234 || (_text234 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.237,
    y: -3554.4807
  })), _text235 || (_text235 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78003
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78003
  }))), _text236 || (_text236 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.0863,
    y: -3875.519
  })), _text237 || (_text237 = /*#__PURE__*/React.createElement("text", {
    x: 277.98999,
    y: 535.94006
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.98999,
    y: 535.94006
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m471.95 253.05c0 120.9-98.006 218.91-218.91 218.91s-218.91-98.006-218.91-218.91 98.006-218.91 218.91-218.91 218.91 98.006 218.91 218.91",
    fill: "#3392bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 1c-140.83 0-255 114.17-255 255s114.17 255 255 255 255-114.17 255-255-114.17-255-255-255m8.827 44.931c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9",
    fillOpacity: 0.067
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 4.43c-138.94 0-251.57 112.63-251.57 251.57s112.63 251.57 251.57 251.57 251.57-112.63 251.57-251.57-112.63-251.57-251.57-251.57m5.885 38.556c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9",
    fillOpacity: 0.129
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 8.36c-136.77 0-247.64 110.87-247.64 247.64s110.87 247.64 247.64 247.64 247.64-110.87 247.64-247.64-110.87-247.64-247.64-247.64m2.942 31.691c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9",
    fillOpacity: 0.129
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.04 7.86c-135.42 0-245.19 109.78-245.19 245.19 0 135.42 109.78 245.19 245.19 245.19 135.42 0 245.19-109.78 245.19-245.19 0-135.42-109.78-245.19-245.19-245.19zm0 26.297c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.31,
    strokeWidth: 4.904
  }))), _text238 || (_text238 = /*#__PURE__*/React.createElement("text", {
    x: 729.64001,
    y: 231.35997
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64001,
    y: 231.35997
  }))), _text239 || (_text239 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.90805,
    y: 579.25812
  })), _text240 || (_text240 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.35997
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.35997
  }))), _text241 || (_text241 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.75732,
    y: 258.21997
  })), _text242 || (_text242 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.900009
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.900009
  }))), _text243 || (_text243 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.71869,
    y: -469.1264
  })), _text244 || (_text244 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37001
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37001
  }))), _text245 || (_text245 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.3573,
    y: -1337.802
  })), _text246 || (_text246 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text247 || (_text247 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.20654,
    y: -1658.8303
  })), _text248 || (_text248 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77002
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77002
  }))), _text249 || (_text249 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.237,
    y: -3554.4807
  })), _text250 || (_text250 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78003
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78003
  }))), _text251 || (_text251 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.0863,
    y: -3875.519
  })), _text252 || (_text252 = /*#__PURE__*/React.createElement("text", {
    x: 277.98999,
    y: 535.94006
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.98999,
    y: 535.94006
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m167.35 117.6c-6.76 10.15-8.37 31.47-3.2 44.5-18.25 15.52-21.15 57.19-12.78 83.43-27.37.05-55.702-.84-75.897 6.36l10.425 10.42c-3.302.94-6.522 1.96-9.63 3.08l204.78 204.79c107.67-13.75 190.9-105.72 190.9-217.13 0-.88-.03-1.75-.04-2.63l-132.82-132.82c-9.78.35-17.02 1.79-25.56 5.56-6.57 2.9-14.02 10.49-20.78 11.12-6.89.65-16.4-3.46-25.55-3.97-21.75-1.19-38.44 1.05-54.32 5.57-12.8-8.49-25.16-17.37-45.53-18.28z",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m339.08 117.61c4.6938 10.659 7.7342 28.363 3.1978 41.322 18.554 15.842 24.929 54.353 15.975 85.824 26.446 2.0176 57.942-.97109 78.279 7.1446-19.008-2.4433-44.967-7.2373-69.485-5.5678-4.6452.31687-11.53-.17675-11.193 6.3589 28.383 2.231 56.584 4.6539 79.885 11.931-23.112-3.7755-51.162-9.5244-79.885-10.326-11.866 23.408-35.729 34.915-68.689 37.338 3.5427 7.7062 10.326 10.643 11.985 23.043 2.4714 18.526-3.8671 45.655 2.3873 58.006 3.0006 5.917 7.8915 6.0733 11.188 11.132-8.0715 9.5524-28.087-1.0713-30.361-11.132-3.9037-17.231 5.945-43.944-4.7864-55.623.75768 18.791-4.4448 45.188.79863 61.973 2.0661 6.6036 8.0316 9.1504 6.3912 15.1-37.518 3.811-21.84-48.554-27.97-79.465-5.6605.40094-3.173 8.4768-3.1935 11.92-.16058 30.189 6.1779 71.586-26.357 67.545-.95061-6.3428 4.365-8.5005 6.3902-14.294 5.9332-16.986-1.1112-42.292 1.6091-62.792-12.416 9.3595 1.3041 42.044-6.3902 58.804-4.4329 9.644-18.719 13.841-29.555 9.5362 1.4119-7.1813 8.826-6.0216 11.974-12.714 4.3974-9.3271.0323-22.763 1.6005-36.551-22.984 4.586-40.811-.66607-49.537-15.1-3.9037-6.4775-4.8705-14.119-9.588-19.862-4.6938-5.7446-12.196-6.5206-14.37-14.298 28.463-6.8526 29.555 29.294 55.118 30.189 7.8387.28454 11.92-2.2623 19.168-3.9673 2.0295-9.1148 6.3751-15.91 12.781-20.672-31.809-4.3542-58.079-14.258-70.293-38.132-28.917 1.4238-55.377 5.2833-79.885 11.116 22.245-8.0801 49.686-10.976 79.088-11.931-1.7331-10.415-16.926-7.5553-26.357-7.1489-17.527.77816-39.592 2.9564-53.525 5.5721 20.196-7.2007 48.533-6.3029 75.898-6.3589-8.369-26.236-5.4676-67.911 12.781-83.431-5.1712-13.03-3.5664-34.352 3.1935-44.502 20.375.91505 32.732 9.7971 45.536 18.281 15.875-4.5138 32.571-6.7599 54.32-5.5646 9.1471.50548 18.663 4.6172 25.551 3.9673 6.7599-.63373 14.21-8.2202 20.773-11.116 8.549-3.7755 15.782-5.2154 25.563-5.5678",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.2cae1be336f1f15328ade671bed1aa73.svg";
export { ForwardRef as ReactComponent };